export default __webpack_public_path__ + "static/media/shiba-inu-shib-logo.46c02907.svg";